if (!customElements.get('liposomal-media')) {
  class LiposomalMedia extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');

      if (!this.video || this.dataset.autoplay !== 'true') return;

      this.video.muted = true;
      this.video.preload = 'none';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.controls = true;
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.startVideo();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.startVideo();
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.15 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    startVideo() {
      this.video.preload = 'metadata';
      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          this.video.controls = true;
        });
      }
    }
  }

  customElements.define('liposomal-media', LiposomalMedia);
}
